import React, {Component} from 'react';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import ClientsList from './ClientsList';
import ClientDataService from "./services/client.service";
import * as FaIcons from "react-icons/fa";
import { Button, Container, FormControl, FormLabel } from 'react-bootstrap';
import { NewHeader, PageHeader } from './AuxiliaryFunctions';
import TopAndSideBar from './TopAndSideBar';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

class Clients extends Component {

  constructor(props) {
    super(props);
    this.onChangeClientFilterByDescr = this.onChangeClientFilterByDescr.bind(this);
    this.onChangeSortField = this.onChangeSortField.bind(this);
    this.onChangeSortType = this.onChangeSortType.bind(this);
    this.performSearch = this.performSearch.bind(this);

    this.state = {
      listOfClients: null,
      ClientFilterByDescr: '',
      SortField: 'id',
      SortType: 'ASC'
    };
  }  

  onChangeSortType() {
    this.setState({
      SortType: (this.state.SortType == 'DESC')?'ASC':'DESC'
    });
    this.performSearch(this.state.ClientFilterByDescr,this.state.SortField,this.state.SortType);    
  }

  onChangeSortField(e) {
    this.setState({
      SortField: e.target.value
    });
    this.performSearch(this.state.ClientFilterByDescr,e.target.value,this.state.SortType);
  }

  onChangeClientFilterByDescr(e) {
    this.setState({
        ClientFilterByDescr: e.target.value
    });
    this.performSearch(e.target.value,this.state.SortField,this.state.SortType);
  }

  componentDidMount() {
    this.performSearch(this.state.ClientFilterByDescr, this.state.SortField,this.state.SortType);  
  }

  performSearch = (descr,sortfield,sorttype) => {
    ClientDataService.getClientByDescr(descr,sortfield,sorttype)
      .then(response => {
        console.log(response.data);
        this.setState({
          listOfClients: response.data
        });
        console.log(this.state.listOfClients);
      })
      .catch(e => {
        console.log(e);
      });
  };

  searchWithEnter = (event)=> {
    if (event.keyCode === 13) {
      this.performSearch();
    }
  }  

  render (){
    return (
      <>
      <div style={{display:"flex", flexDirection:"column",width:"100%"}}>
        <TopAndSideBar />
        <NewHeader headerTitle={"Clients"}/>
        <div style={{padding:"0 8vw",}}>
          <Container>
            <Row className='mb-2 d-flex'>
              <Col lg={true}>
                <FormLabel className='mb-2'>Filter by Client Name:</FormLabel>       
                <FormControl type="text" name="filterbyclientname" id="filterbyclientname" onChange={this.onChangeClientFilterByDescr}></FormControl>
              </Col>
              <Col lg={true}>
                <FormLabel className='mb-2'>Sort By:</FormLabel>       
                  <FormControl as='select' onChange={this.onChangeSortField}>
                    <option value="id">Client ID</option>
                    <option value="clientname">Client Name</option>
                  </FormControl>
              </Col>
              
              <Col sm={true}>
                <FormLabel className='mb-2'>Asc/Desc:</FormLabel>       
                <FormControl style={{maxWidth:"50px"}} as="button" onClick={this.onChangeSortType}><FaIcons.FaSortAmountDownAlt/></FormControl>
              </Col>          
            </Row>
            <Link to="/new-client" className="mr-2 btn btn-primary">New Client</Link>            
            <Button className="m-2 btn btn-primary">Export</Button>        
            <Row>
              <ClientsList listOfClients = {this.state.listOfClients} mode={0}/>      
            </Row>
          </Container>          
        </div>      
      </div>
      </>
    )
  }
}

export default Clients;